import 'leaflet.markercluster'
import 'leaflet-polylinedecorator'

import BaseSchemaDrawer from '@/utils/map/BaseSchemaDrawer'
import { OBJECT as objectsTypes } from '@/utils/map/types'
import { map as mapEndpoints } from '@/api/api-endpoints'
import { getMSNIcon, getGarbageIcon, getTkoIcon } from '@/utils/map/icon'

class ObjectDrawer extends BaseSchemaDrawer {
  layerConfigData = {
    garbage: {
      className: 'cluster-marker',
      iconType: 'wasteCreators',
    },
    settlement: {
      className: 'cluster-marker',
      iconType: 'set',
    },
    msn: {
      className: 'cluster-marker msn',
      iconType: 'places',
    },
    dump: {
      className: 'cluster-marker heap',
      iconType: 'dump',
    },
    object: {
      className: 'cluster-marker object',
      iconType: 'garbage',
    },
    car: {
      className: 'cluster-marker transport',
      iconType: 'transp',
    },
    transport: {
      className: 'cluster-marker transport',
      iconType: 'transp',
    },
  }

  createObjectForMap(data) {
    return Object.assign(data, {
      type: data.type,
      lat: data.lat || data.latitude,
      lng: data.lon || data.longitude,
      showAfterZoom: 8,
      layerConfig: this.getLayerConfig(data.type, data.id),
      subLayerConfig: this.getSubLayerConfig(data.type, data.subtype || null),
    })
  }

  getLayerConfig(type, id) {
    let dict = {
      [objectsTypes.TKO]: Object.assign({}, this.layerConfigData.object, {
        endpoint: mapEndpoints.objectById(id),
      }),
      [objectsTypes.UNAUTHORIZED_TKO]: Object.assign(
        {},
        this.layerConfigData.dump,
        { endpoint: mapEndpoints.objectById(id) }
      ),
      [objectsTypes.UNAUTHORIZED_HEAP]: Object.assign(
        {},
        this.layerConfigData.dump,
        { endpoint: mapEndpoints.heapById(id) }
      ),
      [objectsTypes.GARBAGE]: Object.assign({}, this.layerConfigData.garbage, {
        endpoint: mapEndpoints.sourceById(id),
        fromCache: false,
      }),
      [objectsTypes.MSN]: Object.assign({}, this.layerConfigData.msn, {
        endpoint: mapEndpoints.msnById(id),
      }),
      [objectsTypes.OPERATOR_TRANSPORT]: Object.assign(
        {},
        this.layerConfigData.transport,
        { endpoint: mapEndpoints.transportById(id) }
      ),
      [objectsTypes.CAR]: Object.assign({}, this.layerConfigData.car, {
        endpoint: '',
      }),
      [objectsTypes.CITY]: Object.assign({}, this.layerConfigData.settlement, {
        endpoint: mapEndpoints.settlement(id),
      }),
      default: Object.assign({}, this.layerConfigData.settlement, {
        endpoint: mapEndpoints.settlement(id),
      }),
    }
    return Object.assign({ showMore: true }, dict[type] || dict['default'])
  }

  getSubLayerConfig(type, subtype) {
    let dict = {
      [objectsTypes.TKO]: { iconType: getTkoIcon(subtype) },
      [objectsTypes.UNAUTHORIZED_TKO]: { iconType: 'noThrash' },
      [objectsTypes.UNAUTHORIZED_HEAP]: { iconType: 'thrash' },
      [objectsTypes.GARBAGE]: { iconType: getGarbageIcon(subtype) },
      [objectsTypes.MSN]: { iconType: getMSNIcon(subtype) },
      [objectsTypes.OPERATOR_TRANSPORT]: { iconType: 'transport' },
      [objectsTypes.CAR]: { iconType: 'car' },
      [objectsTypes.CITY]: { iconType: getGarbageIcon(3) },
      default: { iconType: getGarbageIcon(3) },
    }
    return Object.assign({ showMore: true }, dict[type] || dict['default'])
  }

  bringToMarker(obj, zoomTo) {
    this.updateZoom()
    let zoom = zoomTo || obj.showAfterZoom || this._zoom
    if (zoom >= this._zoom) {
      zoom = zoom + 1
    }
    if (zoom < 8) {
      zoom = 9
    }
    let marker = this.getOrCreateMarker(obj)
    let latLng = marker.getLatLng()

    this._map.setView(latLng, zoom)
    this.drawIfNotExist(marker)
    this.createPopup(marker, { forceReDraw: true })
    return marker
  }

  drawMode = true

  refreshMap(
    settlements = null,
    tkoObjects = null,
    garbageSources = null,
    unauthorizedTkos = null,
    unauthorizedHeaps = null,
    msnContainers = null
  ) {
    this.removeAllObjects()
    if (settlements) {
      this.setCities(settlements, this.drawMode)
    }
    if (tkoObjects) {
      this.setTkoObjects(tkoObjects, this.drawMode)
    }
    if (garbageSources) {
      this.setGarbageSources(garbageSources, this.drawMode)
    }
    if (garbageSources) {
      this.setUnauthorizedTkos(unauthorizedTkos, this.drawMode)
    }
    if (unauthorizedHeaps) {
      this.setUnauthorizedHeaps(unauthorizedHeaps, this.drawMode)
    }
    if (msnContainers) {
      this.setMSNContainers(msnContainers, this.drawMode)
    }
    this.$emitter.emit('geo.threadsDrawer.refreshed', {})
  }
}

export default ObjectDrawer
